import Event from '../../../lib/event';

export default [
    'setQuery',
    'submitQuery',
    'quickFilter',
    'sortTable'
].reduce(function (acc, type) {
    acc[type] = Event(type);
    return acc;
}, {});